import { render, staticRenderFns } from "./HomeProductSales.vue?vue&type=template&id=23fde4b7&"
import script from "./HomeProductSales.vue?vue&type=script&lang=js&"
export * from "./HomeProductSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports